import React, { useEffect } from "react";

const ReviewsWidget=()=>{


  useEffect(()=>{
      const script = document.createElement('script');
      script.src = "https://reviewsonmywebsite.com/js/v2/embed.js?id=8e7313fc946fd3d8c15c886f791a7ab8";
      script.async = true;
      document.body.appendChild(script);
      
  return () => { document.body.removeChild(script); } 
  })
 
  
    return (
      <>
      <div data-romw-token="HuQOXBypHvEOVe0Ibpy2TdLfTbEWsZduOakJWEF2tiEwzSc9y0"></div>
      {/* <div style={{width:"100%"}} data-token="1clT6ikyNHmZhVYW8uVtQQMpgIW6BHsqODNR2okoLa17Qzs6vI" className="romw-reviews"/> */}
      </>
    );
  
}


export default React.memo(ReviewsWidget);
